import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Query } from 'react-apollo'
import { Loader } from '../components'
import messages from '../constants/messages'
import { SINGLE_RELAY_QUERY } from '../constants/queries'
import ResizableTable from '../components/ShootersTable/ResizableTable'
import LoadMore from '../components/LoadMore'

import { ErrorTemplate, LoadingTemplate } from '../Middleware/ResponseMiddleware'
import Message from '../views/Message'

class LagvisListTable extends Component {
  static propTypes = {
    organizationId: PropTypes.string,
    organizationGroup1Id: PropTypes.string,
    componentsTree: PropTypes.object,
    postsLimit: PropTypes.number,
  }

  static defaultProps = {
    postsLimit: 20,
    organizationGroup1Id: '',
  }

  state = {
    canLoadMore: true,
    postsLimit: this.props.postsLimit,
  }
  isNewLoading = true

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.organizationId !== this.props.organizationId) {
      this.setState({
        canLoadMore: true,
      })
    }
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (nextProps.number !== this.props.number || nextProps.organizationId !== this.props.organizationId) {
      this.isNewLoading = true
    }
  }

  resolveComponent = (organizationGroup1Id, organizationGroup2Id = null) => {
    if (!this.props.componentsTree.hasOwnProperty(organizationGroup1Id)) {
      return this.props.componentsTree.default
    }

    if (!this.props.componentsTree[organizationGroup1Id].hasOwnProperty(organizationGroup2Id)) {
      return this.props.componentsTree[organizationGroup1Id].default
    }

    return this.props.componentsTree[organizationGroup1Id][organizationGroup2Id]
  }

  load = (fetchMore, data) => {
    return fetchMore({
      variables: {
        offset: data.getRelay[0].targets.length,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult.getRelay[0].targets.length) {
          this.setState({
            canLoadMore: false,
          })
          return prev
        }

        if (fetchMoreResult.getRelay[0].targets.length < this.state.postsLimit) {
          this.setState({
            canLoadMore: false,
          })
        }

        return {
          ...data,
          getRelay: [
            {
              ...data.getRelay[0],
              targets: [...data.getRelay[0].targets, ...fetchMoreResult.getRelay[0].targets],
            },
          ],
        }
      },
    })
  }

  render() {
    const { organizationId, number } = this.props
    const { canLoadMore, postsLimit } = this.state

    return organizationId ? (
      <Query
        query={SINGLE_RELAY_QUERY}
        variables={{
          relayGroupOrganizationId: organizationId,
          number,
          limit: postsLimit,
          offset: 0,
        }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data, fetchMore }) => {
          if (loading && this.isNewLoading) {
            return <LoadingTemplate />
          }

          this.isNewLoading = false

          if (error) {
            return ErrorTemplate(error)
          }

          if (!data.getRelay) {
            return <Message text={messages.refineSearch} />
          }

          const shooters = data.getRelay[0].targets

          if (!shooters.length) {
            return <Message text={messages.nothingFound} />
          }

          const Component = this.resolveComponent(this.props.organizationGroup1Id)

          return (
            <>
              <LoadMore isLoadingMore={loading} canLoadMore={canLoadMore}>
                <ResizableTable
                  updateParameters={{
                    organizationId,
                  }}
                >
                  <Component data={data} />
                </ResizableTable>
                {this.state.loadingMore && <Loader />}
              </LoadMore>
            </>
          )
        }}
      </Query>
    ) : (
      <Message text={messages.refineSearch} />
    )
  }
}

export default LagvisListTable
